class RoundNearestStep {
  constructor(options = {}) {
    this.config = {
      inputs: () => document.querySelectorAll('.RoundNearestStep'),
      ...options
    };
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    const { inputs } = this.config;

    inputs().forEach(input => {
      input.addEventListener('change', e => {
        const { min, max, step, dataset } = input;

        const { roundCeil, roundFloor } = dataset;
        if (parseInt(e.target.value, 10) > parseInt(max, 10)) {
          e.target.value = max;
          return;
        }

        if (parseInt(e.target.value, 10) < parseInt(min, 10)) {
          e.target.value = min;
          return;
        }

        const modulo = e.target.value % step;
        if (modulo === 0) return;

        const remain = step - modulo;
        const ceilNumber = remain <= step / 2 || (roundCeil && roundCeil === 'true');
        const floorNumber = roundFloor && roundFloor === 'true';

        if (ceilNumber && !floorNumber) {
          if (parseInt(e.target.value + remain, 10) > parseInt(max, 10)) {
            e.target.value = max;
          } else {
            e.target.value = parseInt(e.target.value, 10) + remain;
          }
        } else {
          e.target.value -= modulo;
        }
      });
    });
  }
}

export default RoundNearestStep;
